import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Check, View, Waiting } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { SetBVIDone } from './SetBVIDone';
import { deleteVehicleProperty, setVehicleProperty } from '../../../Vehicles/actions';
import { refreshBoards } from '../../actions';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';

const Container = styled.div``;

const STATE = {
  approve: false,
};

/* eslint-disable react/prefer-stateless-function */
class BVIStep2ErrorComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  renderApprove() {
    if (this.props.work) return;
    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('kanbanboards.cell.BVIStep2Error.modal.title')}>
        {['BVI_step2_started', 'machtigingsnummer', 'BVI_step2_2.4.1', 'BVI_step2_2.4.2'].map(propName => {
          if (this.vehicle[propName])
            return (
              <div key={propName}>
                <Check />
                {propName}
              </div>
            );
          return (
            <div key={propName}>
              <Waiting />
              {propName}
            </div>
          );
        })}
        <br />
        <ModalControls>
          {this.props.work ? (
            <Loader small />
          ) : (
            <>
              <Button onClick={this.reset.bind(this)}>{this.lbl('ok')}</Button>
              <Button onClick={() => this.props.retry(this.setStateFn({ approve: false }))}>{this.lbl('retry')}</Button>
              <SetBVIDone vehicle={this.vehicle} onComplete={this.reset.bind(this)} />
            </>
          )}
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton onClick={this.setStateFn({ approve: !this.state.approve })}>
                  <View />
                </CellButton>

                {/* <CellButton onClick={() => this.toHelgaVehicle(vehicle.vehicle_helga_id)}>
                  <img height="23" src="/public/helga_icon.svg" />
                </CellButton> */}
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

BVIStep2ErrorComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
    ]),
  });

  function mapDispatchToProps(dispatch, ownProps) {
    return {
      dispatch,
      retry(callback) {
        const { id } = ownProps.cell.vehicle;
        dispatch(deleteVehicleProperty(id, 'bvi_step2', () => {
          dispatch(deleteVehicleProperty(id, 'BVI_step2_2.4.1', () => {
            dispatch(deleteVehicleProperty(id, '2.2complete', () => {
              dispatch(deleteVehicleProperty(id, '2.3complete', () => {
                dispatch(deleteVehicleProperty(id, 'bvi_step2_error', () => {
                  dispatch(deleteVehicleProperty(id, 'BVI_log', () => {
                    dispatch(deleteVehicleProperty(id, '2.1_complete', () => {
                      dispatch(deleteVehicleProperty(id, '2.1complete', () => {
                      dispatch(deleteVehicleProperty(id, 'BVI_step2_2.3', () => {
                        dispatch(deleteVehicleProperty(id, 'machtigingsnummer', () => {
                          dispatch(deleteVehicleProperty(id, 'bvi_error', () => {
                            dispatch(deleteVehicleProperty(id, 'BVI-2.4-started', () => {
                              dispatch(deleteVehicleProperty(id, 'BVI_step2_started', () => {
                                dispatch(refreshBoards());
                                callback?.();
                                if (ownProps.onComplete) ownProps.onComplete();
                              }));
                            }));
                          }));
                          }));
                        }));
                      }));
                    }));
                  }));
                }));
              }));
            }));
          }));
        }));
      },
    };
  }
  

//BVI_step2_2.4.1
// bvi_done
// 2.2complete
// 2.3complete
// bvi_step2_error
// bvi_error
// BVI_log
// 2.1_complete
// BVI_step2_2.3
// machtigingsnummer
// BVI-2.4-started
// bot_BVI_2
// BVI_step2_started

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const BVIStep2Error = compose(
  withConnect,
  withRouter,
)(BVIStep2ErrorComp);
